import { createSlice } from "@reduxjs/toolkit";

type sliceType = {
  tabs: {
    logo: string;
    header: string;
    urls: string[];
    currentURLIndex: number;
    backward: boolean;
    forward: boolean;
  }[];
  activedTabIndex: number;
  staredWebs: {
    logo: string;
    header: string;
    urls: string[];
    currentURLIndex: number;
    backward: boolean;
    forward: boolean;
  }[];
};

const initialState: sliceType = {
  tabs: [
    {
      logo: "https://upload.wikimedia.org/wikipedia/commons/0/09/IOS_Google_icon.png",
      header: "Google",
      urls: ["https://www.google.com/?igu=1"],
      currentURLIndex: 0,
      backward: false,
      forward: false,
    },
  ],
  activedTabIndex: 0,
  staredWebs: [
    {
      logo: "https://upload.wikimedia.org/wikipedia/commons/0/09/IOS_Google_icon.png",
      header: "Google",
      urls: ["https://www.google.com/?igu=1"],
      currentURLIndex: 0,
      backward: false,
      forward: false,
    },
    {
      logo: "data:image/png;base64,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",
      header: "Github",
      urls: ["https://github.com/vito-mohagheghian/wins-11"],
      currentURLIndex: 0,
      backward: false,
      forward: false,
    },
    {
      logo: "https://vito-dev.ir/_next/static/media/v-icon.794f9f25.svg",
      header: "Vito Mohagheghian",
      urls: ["https://vito-dev.ir"],
      currentURLIndex: 0,
      backward: false,
      forward: false,
    },
    {
      logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6b61CNVBi57OFfU9LY6XPY9toX9Em20M-8w&usqp=CAU",
      header: "Coffee be de (Support)",
      urls: ["https://www.coffeebede.com/vitomohagheghian"],
      currentURLIndex: 0,
      backward: false,
      forward: false,
    },
  ],
};

const edgeAppSlice = createSlice({
  name: "edge",
  initialState,
  reducers: {
    changeTabHandler: (state, action) => {
      const newIndex = action.payload;

      state.activedTabIndex = newIndex;
    },
    newTabHandler: (state) => {
      state.tabs.push({
        logo: "",
        header: "New tab",
        urls: ["https://www.google.com/?igu=1"],
        currentURLIndex: 0,
        backward: false,
        forward: false,
      });
      state.activedTabIndex = state.tabs.length - 1;
    },
    newBlankTabHandler: (state, action) => {
      const url = action.payload;

      state.tabs.push({
        logo: "",
        header: "New tab",
        urls: [url],
        currentURLIndex: 0,
        backward: false,
        forward: false,
      });

      state.activedTabIndex = state.tabs.length - 1;
    },
    closeTab: (state, action) => {
      const tabIndex = action.payload;
      if (state.tabs.length > 1 && state.tabs[tabIndex - 1]) {
        state.activedTabIndex = tabIndex - 1;
        console.log(tabIndex);
      } else {
        state.activedTabIndex = 0;
      }

      state.tabs.splice(tabIndex, 1);
    },
    changeUrlHandler: (state, action) => {
      let newURL = action.payload;

      if (
        newURL.slice(0, 8) !== "https://" &&
        newURL.slice(0, 7) !== "http://"
      ) {
        newURL = "https://" + newURL;
      }

      state.tabs[state.activedTabIndex].urls.push(newURL);

      state.tabs[state.activedTabIndex].currentURLIndex =
        state.tabs[state.activedTabIndex].urls.length - 1;

      state.tabs[state.activedTabIndex].backward = true;
      state.tabs[state.activedTabIndex].forward = false;
    },
    backwardHandler: (state) => {
      if (state.tabs[state.activedTabIndex].currentURLIndex >= 1) {
        state.tabs[state.activedTabIndex].forward = true;

        state.tabs[state.activedTabIndex].currentURLIndex--;

        if (state.tabs[state.activedTabIndex].currentURLIndex < 1) {
          state.tabs[state.activedTabIndex].backward = false;
        }
      }
    },
    forwardHandler: (state) => {
      if (
        state.tabs[state.activedTabIndex].currentURLIndex <
        state.tabs[state.activedTabIndex].urls.length - 1
      ) {
        state.tabs[state.activedTabIndex].backward = true;

        state.tabs[state.activedTabIndex].currentURLIndex++;

        if (
          state.tabs[state.activedTabIndex].currentURLIndex ===
          state.tabs[state.activedTabIndex].urls.length - 1
        ) {
          state.tabs[state.activedTabIndex].forward = false;
        }
      }
    },
  },
});

export const edgeAppActions = edgeAppSlice.actions;

export default edgeAppSlice;
